import { SeverityMapper } from '../../../common/mappers/SeverityMapper';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { PriorityFix } from '../models/PriorityFix';
import { Project } from '../models/valueObjects/Project';

export class PriorityFixMapper {
  private readonly encoder: GQLIdEncoder;
  private readonly severityMapper: SeverityMapper;

  constructor() {
    this.encoder = new GQLIdEncoder();
    this.severityMapper = new SeverityMapper();
  }

  mapToDomain(data: any): PriorityFix[] {
    if (!data) return [];
    const output: PriorityFix[] = [];

    for (const { node: priorityFix } of data) {
      const project = priorityFix.project ? new Project(this.encoder.decode(priorityFix.project.id), priorityFix.project.id, priorityFix.project.name) : null;
      const severity = this.severityMapper.mapSeverity(priorityFix.severity);

      const fix = new PriorityFix(priorityFix.number, priorityFix.title, priorityFix.shortExplanation ?? '', severity, project);
      output.push(fix);
    }

    return output;
  }
}
